module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "down-root"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "down-link",
    attrs: {
      "href": _vm.link
    },
    on: {
      "click": _vm.clickLink
    }
  }, [_vm._v("点击下载APP立即体验")])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "success-tip"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v("恭喜你注册成功")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1627e5be","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/downLoad.vue
// module id = 312
// module chunks = 1